import React, {FC, useMemo} from 'react';
import messages from '../../../messages';
import {STATUSES} from './constant';
import {InvoiceFilters} from './types';
import AsyncItemPicker from 'components/async-item-picker';
import {FilterMap} from 'features/table/slice/types';
import {useTranslation} from 'react-i18next';
import {Col, Collapse, FormGroup, Row} from 'reactstrap';
import DateRangeInput from 'components/date-range-input';
import SearchSection from 'features/table/compenents/search-section';

interface FilterProps {
  filters: FilterMap<InvoiceFilters>;
  onChangeFilters: (key: InvoiceFilters, value: any) => void;
  onClearFilters?: () => void;
}

const Filters: FC<FilterProps> = props => {
  const {t} = useTranslation();
  const {filters, onChangeFilters, onClearFilters} = props;

  return (
    <SearchSection
      onChangeFilters={onChangeFilters}
      onClearFilters={onClearFilters}
      filters={filters}
    >
      <Row className="mb-3">
        <Col lg="6" md="6">
          <DateRangeInput
            label={t(...messages.billingDate())}
            value={filters['filter[billing_date]'] as string}
            onChange={o => onChangeFilters('filter[billing_date]', o)}
          />
        </Col>
        <Col lg="6" md="6">
          <FormGroup>
            <AsyncItemPicker
              endPoint="data/commercial-types?invoice"
              className="mb-1"
              label={t('invoicesPage.type')}
              value={filters['filter[commercial_type_id]']}
              onChange={o => onChangeFilters('filter[commercial_type_id]', o)}
            />
          </FormGroup>
        </Col>
      </Row>
    </SearchSection>
  );
};

export default Filters;
